import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const listaFeriados = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.SUPERVISOR.FERIADOS.LISTA}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default listaFeriados;